import { DECommonTable } from 'components/DataExpansionComponents/Common/CommonTable/CommonTable'
import { DataTableProvider } from 'components/DataTable'
import { ContactResponse } from 'models/contacts'
import useApiService from 'services/api'
import { ColumnsStoreProvider } from 'stores/ColumnsStore/ColumnsStoreProvider'
import { dataTableSortingStoreRepo } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { IColumnVisibility } from '../../../../DataTable/types'
import { useConvenienceTableCols } from './ConvenienceTableColumns'
import { FilterIdentifier } from 'models/saved_view'
import { ConvenienceFilterset } from './ConvenienceFilterset'
import { StandardSummaryResponse } from 'models/paginated-response'
import ConvenienceExportModal from 'components/Modals/ExportModal/ConvenienceExportModal'
import { useUnifiedTableActions } from 'services/opportunities/useUnifiedTableActions'

type SortableFields = (keyof ContactResponse | string)[]

// Convenience chain detail link reads `cstore.id` (GooglePlaceBase name cell,
// accesor="cstore"). App vertical `convenience` maps to unified `cstore`.
const UNIFIED_ROW_CONFIG = { nestKey: 'cstore' }

const sortableFields: SortableFields = [
  'note_count',
  'contact_count',
  'deal_count',
  'name',
  'domain',
  'reviews_avg',
  'reviews_cnt',
  'doors_cnt',
]

export interface ConvenienceTableProps {
  setTotalRowsCount?: (count: StandardSummaryResponse) => void
  pageParamName?: string
  baseFilters?: Record<string, any>
  tableKey: string
  filterIdentifierModifier?: FilterIdentifier
  hideCreateCompanyButton?: boolean
}

function ConvenienceTableComponent(props: ConvenienceTableProps) {
  const api = useApiService()
  const { tableKey, ...rest } = props
  const { sorting } = dataTableSortingStoreRepo.getStore(props.tableKey)()
  const columns = useConvenienceTableCols({
    sorting,
    inCampaigns: props.baseFilters?.main_campaign,
  })
  const { listAction, summaryAction } = useUnifiedTableActions(
    'convenience',
    UNIFIED_ROW_CONFIG,
    {
      listAction: api.getConvenienceList,
      summaryAction: api.getConvenienceSummary,
    }
  )
  return (
    <DECommonTable
      {...rest}
      tableKey={tableKey}
      columns={columns}
      sortableFields={sortableFields}
      filterIdentifier="CONVENIENCE_TABLE"
      apiGetListAction={listAction}
      apiGetSummaryAction={summaryAction}
      companyTypeSlug="convenience"
      tableTypeSlug="convenience"
      searchPlaceholder="Search convenience by name"
      FilterSet={ConvenienceFilterset}
      ExportModal={ConvenienceExportModal}
    />
  )
}

export function ConvenienceTable(
  props: ConvenienceTableProps & {
    defaultColumnVisibility?: IColumnVisibility<any>
  }
) {
  const { tableKey, defaultColumnVisibility, ...rest } = props

  return (
    <ColumnsStoreProvider
      tableKey={tableKey}
      defaultColumnVisibility={defaultColumnVisibility}
      savedPresetsIdentifier="CONVENIENCE_TABLE"
      preferredGroupOrder={['Target Attributes', 'Campaigns and Deals']}
    >
      <DataTableProvider tableKey={tableKey}>
        <ConvenienceTableComponent tableKey={tableKey} {...rest} />
      </DataTableProvider>
    </ColumnsStoreProvider>
  )
}
